<template>
  <FullDialog @esc="$emit('esc')" :show="show">
    <div class="cpt-dialog-setting-config-content cpt-use-setting flex w-full mx-auto rounded-[20px] overflow-hidden h-full">
      <div class="left-side flex-none w-[256px] pt-[20px] bg-fl-2">
        <template v-for="config in configs">
          <div class="block mx-[24px] overflow-hidden" :key="config.key" v-if="config.data.find(v => !v.isHidden)">
            <span class="type">{{config.name}}</span>
            <template v-for="item in config.data">
              <div 
                v-if="!item.isHidden"
                :key="item.key"
                class="row w-full h-[36px] my-[4px] flex items-center px-[8px] float-right cursor-pointer flex-shrink-0"
                @click="scrollToBlock(item.key)"
                :class="{ active: choosedItem == item.key }"
              >
                <span class="flex-1 font-normal text-[14px] leading-[18px] tracking-[0.01em] text-tx-2">{{ item.title }}</span>
                <span v-if="item.isNew && !setting_data.new_config_clicked_list.includes(item.key)" class="new flex-none h-[16px] w-[32px] bg-er-fl rounded-[8px] flex justify-center items-center"><span class="new-text font-['Roboto'] h-[28px] font-medium text-[22px] leading-[28px] tracking-[0.01em] text-wh-0" style="transform: scale(45%, 45%); transform-origin: center;">New</span></span>
              </div>
            </template>
          </div>
        </template>

        <div class="block last mx-[24px] overflow-hidden" v-if="$slots['side-last']">
          <slot name="side-last"></slot>
        </div>
        <div class="block des mx-[24px] overflow-hidden absolute bottom-0 p-[8px_0px_30px_8px]" v-if="$slots['describe']">
          <slot name="describe"></slot>
        </div>
      </div>
      <div class="right-side w-0 bg-fl-1 flex-1 flex-grow h-full relative">
        <div class="scroll-wrapper w-full max-h-full overflow-y-auto p-[13px_32px_32px] pr-[24px]" ref="setting-scroll-wrapper">
          <div class="scroll-content-wrapper" ref="setting-scroll-content">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </FullDialog>
</template>

<script>

import { mapGetters } from 'vuex';


export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    choosedItem: {
      type: String,
      default: ''
    },
    configs: {
      type: Array,
      default: () => []
    },
    clickBlockCallback:{
      type: Function,
      default: null
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['setting_data'])
  },
  methods: {
    scrollToBlock(key) {
      this.clickBlockCallback && this.clickBlockCallback(key)
      clearTimeout(this.lock_timer);
      this.$emit('update:choosedItem', key)
    },
  },
}
</script>

<style lang="scss">
$main-body-color: $d-tx-2;
.cpt-dialog-setting-config-content {
  background: linear-gradient(to right, $d-fl-2 0%, $d-fl-2 50%, $d-fl-1 50%, $d-fl-1 100%);
  .left-side {
    .block {
      &:not(:last-of-type) {
        padding-bottom: 15px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: 7px;
          height: 1px;
          left: 8px;
          width: calc(100% - 16px);
          background: $d-ln-2;
        }
      }

      &.last {
        &::after {
          display: none;
        }
      }

      .row {
        &:hover {
          background: $d-op-1;
          border-radius: 5px;
        }

        &.active {
          background: $d-op-2;
          border-radius: 5px;
          span {
            font-weight: 700;
            color: $d-tx-1;
          }
        }

        &.warn {
          font-size: 14px;
          line-height: 18px;
          color: $d-er-tx;
        }
      }

      &.des {
        p {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.04em;
          color: $d-tx-3;
        }
      }
    }
  }

  .right-side {
    .scroll-wrapper {
      overflow-y: overlay;
    }
  }
}
</style>
